import { render, staticRenderFns } from "./detailModal.vue?vue&type=template&id=650c32d7&scoped=true"
import script from "./detailModal.vue?vue&type=script&lang=js"
export * from "./detailModal.vue?vue&type=script&lang=js"
import style0 from "./detailModal.vue?vue&type=style&index=0&id=650c32d7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650c32d7",
  null
  
)

export default component.exports